<script>
import Chart from 'chart.js';

export default {
  name: 'AnalyticsMediumsReport',
  props: {
    colors: Array,
    data: Object,
    loading: Boolean
  },
  data() {
    return {
      chart: null
    };
  },
  computed: {
    chartData() {
      if (this.data && this.data.rows) {
        const maxItems = 5;
        let rows = this.data.rows;

        // Aggregate "other" items
        if (rows.length > maxItems) {
          rows = rows.slice(0, maxItems);
        }

        const data = {
          labels: rows.map(row => row[0]),
          datasets: [
            {
              data: rows.map(row => row[1]),
              backgroundColor: this.colors,
              borderColor: 'white',
              borderWidth: 2
            }
          ]
        };

        return data;
      }
    }
  },
  watch: {
    data() {
      this.updateChart();
    }
  },
  mounted() {
    this.chart = new Chart(this.$refs.chart, {
      type: 'doughnut',
      data: {
        labels: [],
        datasets: []
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: true,
          text: this.$t('Traffic Sources')
        },
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: true
          }
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const label = data.labels[tooltipItem.index];
              const value = parseInt(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]).toLocaleString();
              return `${label} (${value})`;
            }
          }
        }
      }
    });
    this.updateChart();
  },
  methods: {
    // Updates and renders the chart
    updateChart() {
      if (this.chartData) {
        this.chart.data = this.chartData;
        this.chart.update();
      }
    }
  }
};
</script>

<template>
  <div v-loading="loading" class="mediums-chart">
    <canvas ref="chart" />
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.mediums-chart {
  position: relative;
  height: 12rem;
  margin-bottom: 1rem;
}
</style>
